// export const WebApiURL="http://localhost:5287/api/"
// export const WebApiURL="https://teko.samsa.org.za/api/api/"
export const WebApiURL="https://www.samsa.org.za/api/api/"
// export const WebApiURL= "http://10.0.0.17/api/api/"
//export const WebApiURL= "http://samsa.org.za/api/api/"
// export const WebApiURL= "http://10.0.0.33:8081/api/"

